<div class="risk-meter {{riskNormalized}} {{ riskLabel | normSelector }}">
  <span [innerHTML]="riskLabel | safehtml"></span>
</div>